import { useTranslation } from "react-i18next";
import { LocationOn, Phone, Email } from "@mui/icons-material";
import { SendButton } from "../../components/button/SendButton";
import { Link } from "react-router-dom";
import { useState } from "react";
import { sendContactEmail } from "../../service/contactService";
import { toast } from "react-toastify";
import PublicIcon from '@mui/icons-material/Public';

export const ContactUs = () => {
  const { t, i18n } = useTranslation();
  // const { width } = useWindowSize();
  const isVietnamese = i18n.language === "vi";

  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    if (name === "phone") {
      const phoneRegex = /^0\d{9}$/;
      if (!phoneRegex.test(value)) {
        setErrors((prev) => ({ ...prev, phone: t("contactus.invalidphone") }));
      } else {
        setErrors((prev) => ({ ...prev, phone: "" }));
      }
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setErrors((prev) => ({ ...prev, email: t("contactus.invalidemail") }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
      }
    }
  };

  const handleSubmit = async () => {
    const newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const phoneRegex = /^0\d{9}$/;

    if (!form.name.trim()) {
      newErrors.name = t("contactus.required");
    }

    if (!form.email.trim()) {
      newErrors.email = t("contactus.required");
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = t("contactus.invalidemail");
    }

    if (form.phone && !phoneRegex.test(form.phone)) {
      newErrors.phone = t("contactus.invalidphone");
    }

    if (!form.message.trim()) {
      newErrors.message = t("contactus.required");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoading(true);
    try {
      await sendContactEmail(form);
      setForm({
        name: "",
        email: "",
        company: "",
        phone: "",
        subject: "",
        message: "",
      });
      toast.success(t("contactus.emailsuccess"));
    } catch (error) {
      console.error("Lỗi gửi mail:", error);
      toast.error(t("contactus.emailerror"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* About us */}
      <div className="bg-cover bg-center h-[260px] md:h-[295px] smAndmd:h-[130px] exact768:h-[120px] exact1024:h-[150px] exact1920:h-[383px]">
        <div className=" md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto pl-[10px]">
          <h1
            className={`inline-block h-[51px] text-5xl text-white font-extrabold ${
              isVietnamese ? "md:text-3xl" : ""
            } mt-[100px] smAndmd:mt-10 exact1024:mt-10`}
          >
            {t("contactus.header")}
          </h1>
        </div>
      </div>

      {/* Get in touch */}
      <div className=" md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] pl-[10px] pt-[180px] exact1920:pt-[50px] mds:pt-[70px] minxl:pt-[50px] minlg:pt-[50px] exact1024:pt-[50px] md:pt-[70px] pb-[5px] mx-auto px-4">
        <h1 className="text-center text-[#1C2045] text-5xl text-[#1C2045] font-extrabold mb-12 md:mb-0 md:text-3xl">
          {t("contactus.getin")}
          <span className="border-b-[10px] pl-2 inline-block h-11 border-[#B9AAFD] md:h-7 md:border-b-[6px] md:text-3xl">
            {t("contactus.touch")}
          </span>
        </h1>
      </div>

      <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] relative mx-auto flex items-center justify-center bg-white p-4 mb-[50px]">
        <div className="flex flex-col xl:flex-col md:flex-col bg-[#f1f6fd] rounded-3xl overflow-hidden max-w-4xl w-full pr-20 xl:pr-0 md:pr-0 mr-[30%] xl:block md:block xl:mr-0 md:mr-0 xl:content-center">
          {/* Form */}
          <div className="flex-1 p-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
              <div className="flex flex-row md:flex-col gap-5">
                <div className="flex-1">
                  <label className="block font-semibold mb-1">
                    {t("contactus.name")}{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t("contactus.enteryourname")}
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className={`w-full p-3 rounded-md border ${
                      errors.name ? "border-red-500" : "border-none"
                    }`}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>
                <div className="flex-1">
                  <label className="block font-semibold mb-1">
                    {t("contactus.email")}{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder={t("contactus.enteryouremail")}
                    className={`w-full p-3 rounded-md border ${
                      errors.email ? "border-red-500" : "border-none"
                    }`}
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
              </div>

              <div className="flex flex-row md:flex-col gap-5">
                <div className="flex-1">
                  <label className="block font-semibold mb-1">
                    {t("contactus.company")}
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={form.company}
                    onChange={handleChange}
                    placeholder={t("contactus.enteryourcompany")}
                    className="w-full p-3 rounded-md"
                  />
                </div>
                <div className="flex-1">
                  <label className="block font-semibold mb-1">
                    {t("contactus.phone")}
                  </label>
                  <input
                    type="text"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder={t("contactus.enteryourphoneno")}
                    className="w-full p-3 rounded-md"
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-4">
              <label className="block font-semibold mb-1">
                {t("contactus.subject")}
              </label>
              <input
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder={t("contactus.enteryoursubject")}
                className="w-full p-3 rounded-md"
              />
            </div>
            <div className="mt-4">
              <label className="block font-semibold mb-1">
                {t("contactus.message")} <span className="text-red-500">*</span>
              </label>
              <textarea
                placeholder={t("contactus.enteryourmessage")}
                rows={4}
                className={`w-full p-3 rounded-md border ${
                  errors.message ? "border-red-500" : "border-none"
                }`}
                name="message"
                value={form.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && (
                <p className="text-red-500 text-sm">{errors.message}</p>
              )}
            </div>
            <div className="mt-6 flex justify-center">
              <SendButton
                title={
                  loading ? t("contactus.sending") : t("contactus.sendmessage")
                }
                onClick={handleSubmit}
                disabled={loading}
              />
            </div>
          </div>
          {/* Contact Info for desktop (md and up) */}
          <div className="hidden md:block xl:block xl:max-w-full max-w-[400px] mx-auto">
            <div className="bg-[#7052FBE5] text-white flex flex-col gap-2 justify-center p-8 w-full mt-10 rounded-3xl">
              <div className="flex justify-center items-center">
                <h2 className="bg-[#404E7C] text-2xl font-bold mb-6 text-center py-6 px-4 max-w-[400px]">
                  {t("registerasadistributor.contactinformation")}
                </h2>
              </div>
              <div className="flex items-start gap-4 mb-4">
                <LocationOn />
                <p>{t("registerasadistributor.location")}</p>
              </div>
              <div className="flex items-center gap-4 mb-4">
                <Phone />
                <div>
                  <p>1900 6884</p>
                  <p>+84 28 3622 2982</p>
                </div>
              </div>
              <div className="flex items-center gap-4 mb-4">
                <Email />
                <p>info@mobile-id.vn</p>
              </div>
              <div className="flex items-center gap-4">
                <PublicIcon />
                <Link to="https://mobile-id.vn/">www.mobile-id.vn</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="absolute xl:hidden md:hidden right-[4rem]">
          <div className="bg-[#7052FBE5] text-white flex flex-col gap-2 justify-center p-8 max-w-[400px] md:w-[400px] mt-10 mb-6 rounded-3xl">
            <div className="flex justify-center items-center">
              <h2 className="bg-[#404E7C] text-2xl font-bold mb-6 text-center py-6 px-4 max-w-[400px]">
                {t("registerasadistributor.contactinformation")}
              </h2>
            </div>
            <div className="flex items-start gap-4 mb-4">
              <LocationOn />
              <p>{t("registerasadistributor.location")}</p>
            </div>
            <div className="flex items-center gap-4 mb-4">
              <Phone />
              <div>
                <p>1900 6884</p>
                <p>+84 28 3622 2982</p>
              </div>
            </div>
            <div className="flex items-center gap-4 mb-4">
              <Email />
              <p>info@mobile-id.vn</p>
            </div>
            <div className="flex items-center gap-4">
              <PublicIcon />
              <Link to="https://mobile-id.vn/"> www.mobile-id.vn</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
